import React from 'react'
import DataCustomerManagement from '../components/DataCustomerManagement/DataCustomerManagement'

const DataCustomerManagementPage = () => {
  return (
    <>
      <DataCustomerManagement />
    </>
  )
}

export default DataCustomerManagementPage
